export interface ProfileSettingsSelection {
  jobTitle: string;
}
